/*
 * REFONTE 2026-10-21 (lot 3) : compte à rebours « tableau d'affichage à palettes inox » (piste B).
 * Composant partagé (snippets/refonte-countdown.liquid, assets/refonte-countdown.css). Propriétaire : COORDINATEUR (21/10 11:05).
 * - Taille « chip » (cartes) : jours sans zéro de tête et masqués à moins de 24 h (classe sc-cdn--d0), aucune bascule animée.
 * - UN seul minuteur pour tous les blocs [data-sc-cdn] de la page, calé sur la seconde.
 * - Quand un chiffre change : la demi-palette du haut (ancien chiffre) bascule en 250 ms ; rien ne bouge avec
 *   prefers-reduced-motion, ni au premier affichage, ni onglet masqué.
 * - Lecteurs d'écran : texte masqué « Sortie dans 1 jour 4 heures 12 minutes » mis à jour une fois par minute
 *   (role="timer" = pas d'annonce automatique). Chiffres aria-hidden.
 * - Échéance : jamais de chiffres négatifs ; classe is-ended, texte de fin, événement « sc:countdown:end » (bulle).
 * - Blocs insérés plus tard (AJAX, éditeur de thème) : détectés automatiquement ; sinon window.scCountdown.scan(racine).
 */
(function () {
  'use strict';

  if (window.scCountdown) {
    window.scCountdown.scan(document);
    return;
  }

  var items = [];
  var timer = 0;
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var lang = document.documentElement.getAttribute('lang') || 'fr';
  var fmts = {};

  function nowSec() {
    return Math.floor(Date.now() / 1000);
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function unitFormat(unit) {
    if (!(unit in fmts)) {
      try {
        fmts[unit] = new Intl.NumberFormat(lang, { style: 'unit', unit: unit, unitDisplay: 'long' });
      } catch (e) {
        fmts[unit] = null;
      }
    }
    return fmts[unit];
  }

  function part(it, n, unit, idx) {
    var f = unitFormat(unit);
    if (f) return f.format(n);
    return n + ' ' + String(it.units[idx] || '').toLowerCase();
  }

  /* Texte lu : minutes arrondies au supérieur (« 1 minute » à 45 s de l'échéance), unités nulles de tête omises. */
  function srText(it, total) {
    var d = Math.floor(total / 1440);
    var h = Math.floor((total % 1440) / 60);
    var m = total % 60;
    var out = [];
    if (d) out.push(part(it, d, 'day', 0));
    if (d || h) out.push(part(it, h, 'hour', 1));
    out.push(part(it, m, 'minute', 2));
    var txt = (it.label ? it.label + ' ' : '') + out.join(' ');
    /* 02/11 : en allemand, « in » appelle le datif : « Release in 3 Tagen » (et non « 3 Tage ») ; « in 1 Tag » inchangé. */
    if (/^de/i.test(lang) && /\bin$/i.test(it.label)) txt = txt.replace(/(\d) tage\b/gi, '$1 Tagen');
    return txt;
  }

  function makeFlap() {
    var flap = document.createElement('span');
    var num = document.createElement('span');
    flap.className = 'sc-cdn__flap';
    num.className = 'sc-cdn__num';
    num.textContent = '0';
    flap.appendChild(num);
    return flap;
  }

  function flip(flap, old) {
    var leaf = flap.querySelector('.sc-cdn__leaf');
    if (!leaf) {
      leaf = document.createElement('span');
      leaf.className = 'sc-cdn__leaf';
      leaf.addEventListener('animationend', function () {
        leaf.classList.remove('is-on');
      });
      flap.appendChild(leaf);
    }
    leaf.textContent = old;
    leaf.classList.remove('is-on');
    void leaf.offsetWidth;
    leaf.classList.add('is-on');
  }

  function setPair(pair, str, animate) {
    while (pair.children.length < str.length) pair.insertBefore(makeFlap(), pair.firstChild);
    while (pair.children.length > str.length) pair.removeChild(pair.firstChild);
    for (var i = 0; i < str.length; i++) {
      var flap = pair.children[i];
      var num = flap.querySelector('.sc-cdn__num');
      var ch = str.charAt(i);
      if (!num || num.textContent === ch) continue;
      var old = num.textContent;
      num.textContent = ch;
      if (animate) flip(flap, old);
    }
  }

  function emitEnd(el, ts) {
    var ev;
    try {
      ev = new CustomEvent('sc:countdown:end', { bubbles: true, detail: { ts: ts } });
    } catch (e) {
      ev = document.createEvent('CustomEvent');
      ev.initCustomEvent('sc:countdown:end', true, false, { ts: ts });
    }
    el.dispatchEvent(ev);
  }

  function finish(it) {
    if (it.done) return;
    it.done = true;
    for (var k in it.pairs) {
      if (Object.prototype.hasOwnProperty.call(it.pairs, k)) setPair(it.pairs[k], '00', false);
    }
    it.el.classList.add('is-ended');
    it.el.classList.remove('sc-cdn--d3');
    if (it.endedEl) {
      it.endedEl.hidden = false;
      if (it.sr) it.sr.textContent = it.endedEl.textContent;
    }
    emitEnd(it.el, it.ts);
  }

  /* Renvoie false quand le bloc est arrivé à échéance (il sort alors de la liste). */
  function update(it, now) {
    var left = it.ts - now;
    if (left <= 0) {
      finish(it);
      return false;
    }
    var d = Math.floor(left / 86400);
    var h = Math.floor((left % 86400) / 3600);
    var m = Math.floor((left % 3600) / 60);
    var s = left % 60;
    var animate = !it.chip && !it.fresh && !document.hidden && !(reduce && reduce.matches);
    it.el.classList.toggle('sc-cdn--d3', d > 99);
    it.el.classList.toggle('sc-cdn--d0', d === 0);
    if (it.pairs.d) setPair(it.pairs.d, it.chip ? String(d) : pad(d), animate);
    if (it.pairs.h) setPair(it.pairs.h, pad(h), animate);
    if (it.pairs.m) setPair(it.pairs.m, pad(m), animate);
    if (it.pairs.s) setPair(it.pairs.s, pad(s), animate);
    var mins = Math.ceil(left / 60);
    if (mins !== it.srMins) {
      it.srMins = mins;
      if (it.sr) it.sr.textContent = srText(it, mins);
    }
    it.fresh = false;
    return true;
  }

  function bind(el) {
    if (el.__scCdn) return;
    var ts = parseInt(el.getAttribute('data-sc-cdn'), 10);
    var it = {
      el: el,
      ts: isNaN(ts) ? 0 : ts,
      chip: el.classList.contains('sc-cdn--chip'),
      label: el.getAttribute('data-sc-cdn-label') || '',
      units: (el.getAttribute('data-sc-cdn-units') || '').split('|'),
      pairs: {},
      sr: el.querySelector('[data-sc-cdn-sr]'),
      endedEl: el.querySelector('[data-sc-cdn-ended]'),
      srMins: -1,
      fresh: true,
      done: false
    };
    var pairs = el.querySelectorAll('[data-sc-cdn-unit]');
    for (var i = 0; i < pairs.length; i++) it.pairs[pairs[i].getAttribute('data-sc-cdn-unit')] = pairs[i];
    el.__scCdn = it;
    if (update(it, nowSec())) items.push(it);
  }

  function tick() {
    timer = 0;
    var now = nowSec();
    var alive = [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (it.done || !document.documentElement.contains(it.el)) continue;
      if (update(it, now)) alive.push(it);
    }
    items = alive;
    schedule();
  }

  function schedule() {
    if (timer || !items.length) return;
    timer = window.setTimeout(tick, 1000 - (Date.now() % 1000) + 20);
  }

  function scan(root) {
    root = root && root.querySelectorAll ? root : document;
    if (root.nodeType === 1 && root.hasAttribute('data-sc-cdn')) bind(root);
    var list = root.querySelectorAll('[data-sc-cdn]');
    for (var i = 0; i < list.length; i++) bind(list[i]);
    schedule();
  }

  window.scCountdown = { scan: scan };

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) return;
    if (timer) {
      window.clearTimeout(timer);
      timer = 0;
    }
    tick();
  });

  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
  });

  /* Blocs ajoutés après coup (filtres AJAX, rendu de section) : un seul scan par image. */
  if (window.MutationObserver) {
    var pending = false;
    new MutationObserver(function (records) {
      if (pending) return;
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1 || n.classList.contains('sc-cdn__leaf') || n.classList.contains('sc-cdn__flap')) continue;
          if (n.hasAttribute('data-sc-cdn') || n.querySelector('[data-sc-cdn]')) {
            pending = true;
            window.requestAnimationFrame(function () {
              pending = false;
              scan(document);
            });
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }
})();

/* 01/11 (dirigeant) : drop à 00:00, heure de Paris. Au lieu de « vendredi 6 novembre · 0 h » : « Jeudi 5 novembre à minuit
   (heure de Paris) » (choix du dirigeant : en français, « jeudi minuit » est la fin de jeudi). Accueil (heure du drop), page Drops
   (drop mis en avant) et fiche produit (date de sortie), en FR, EN et DE. Autres heures et autres langues : inchangé.
   Retour arrière : retirer ce bloc. */
(function () {
  var LANG = String(document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
  if (LANG !== 'fr' && LANG !== 'en' && LANG !== 'de') return;
  var LOC = { fr: 'fr-FR', en: 'en-GB', de: 'de-DE' }[LANG];
  function parts(d) {
    var o = {};
    var t = {};
    new Intl.DateTimeFormat(LOC, { timeZone: 'Europe/Paris', weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })
      .formatToParts(d).forEach(function (p) { o[p.type] = p.value; });
    new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Paris', hour: '2-digit', minute: '2-digit', hour12: false })
      .formatToParts(d).forEach(function (p) { t[p.type] = p.value; });
    o.H = +t.hour % 24;
    o.M = +t.minute;
    return o;
  }
  function isMidnight(d) {
    if (!d || isNaN(d.getTime())) return false;
    var p = parts(d);
    return p.H === 0 && p.M === 0;
  }
  function parseIso(s) {
    return new Date(String(s || '').replace(/([+-]\d{2})(\d{2})$/, '$1:$2'));
  }
  /* Veille à minuit : « jeudi 5 novembre à minuit », « Thursday 5 November at midnight », « Donnerstag, 5. November, um Mitternacht ». */
  function eve(d, withYear) {
    var a = parts(new Date(d.getTime() - 12 * 3600 * 1000));
    var y = withYear ? ' ' + a.year : '';
    if (LANG === 'fr') return a.weekday + ' ' + (a.day === '1' ? '1er' : a.day) + ' ' + a.month + y + ' à minuit';
    if (LANG === 'en') return a.weekday + ' ' + a.day + ' ' + a.month + y + ' at midnight';
    return a.weekday + ', ' + a.day + '. ' + a.month + y + ', um Mitternacht';
  }
  function cap(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
  }
  /* « , heure de Paris » ou « (heure de Paris) » -> « heure de Paris » */
  function paris(s) {
    s = String(s || '').trim();
    var m = s.match(/\(([^)]*)\)\s*$/);
    if (m) return m[1];
    var i = s.lastIndexOf(', ');
    return i >= 0 ? s.slice(i + 2) : s.replace(/^,\s*/, '');
  }
  function run() {
    try {
      document.querySelectorAll('time[data-sc-hd-date]').forEach(function (t) {
        var s = parseInt(t.getAttribute('data-sc-hd-date'), 10);
        var d = s > 0 ? new Date(s * 1000) : parseIso(t.getAttribute('datetime'));
        if (!isMidnight(d)) return;
        t.textContent = cap(eve(d, false));
        var n = t.nextSibling;
        if (n && n.nodeType === 3 && n.textContent.trim()) n.textContent = ' (' + paris(n.textContent) + ')';
      });
      document.querySelectorAll('.sc-drops__date time[datetime]').forEach(function (t) {
        var d = parseIso(t.getAttribute('datetime'));
        if (!isMidnight(d)) return;
        var p = paris(t.textContent);
        t.textContent = cap(eve(d, true)) + (p ? ' (' + p + ')' : '');
      });
      /* 02/11 : liste du calendrier de la page Drops (.sc-cd__date, sans <time>) : même formule pour un drop à minuit. */
      document.querySelectorAll('.sc-cd__item').forEach(function (li) {
        var c = li.querySelector('[data-sc-cdn]');
        var el = li.querySelector('.sc-cd__date');
        var s = c ? parseInt(c.getAttribute('data-sc-cdn'), 10) : 0;
        if (!el || !(s > 0)) return;
        var d = new Date(s * 1000);
        if (!isMidnight(d)) return;
        var p = /,\s|\(/.test(el.textContent) ? paris(el.textContent) : '';
        el.textContent = cap(eve(d, true)) + (p ? ' (' + p + ')' : '');
      });
      /* Calendrier de la page Drops : tuile « NOV 06 » alignée sur « jeudi 5 novembre à minuit » (contre-audit du 01/11, M2). */
      document.querySelectorAll('.sc-drops__row').forEach(function (r) {
        var c = r.querySelector('[data-sc-cdn]');
        var s = c ? parseInt(c.getAttribute('data-sc-cdn'), 10) : 0;
        if (!(s > 0)) return;
        var d = new Date(s * 1000);
        if (!isMidnight(d)) return;
        var a = new Date(d.getTime() - 12 * 3600 * 1000);
        var day = r.querySelector('.sc-drops__day strong');
        var mon = r.querySelector('.sc-drops__day span');
        if (day) day.textContent = new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Paris', day: '2-digit' }).format(a);
        if (mon && parts(a).month !== parts(d).month) {
          mon.textContent = new Intl.DateTimeFormat(LOC, { timeZone: 'Europe/Paris', month: 'short' }).format(a).replace('.', '').toUpperCase();
        }
      });
      document.querySelectorAll('.release-date-display').forEach(function (p) {
        var box = p.closest('[data-timer-start]');
        var s = box ? parseInt(box.getAttribute('data-timer-start'), 10) : 0;
        if (!(s > 0)) return;
        var d = new Date(s * 1000);
        if (!isMidnight(d)) return;
        var st = p.querySelector('strong');
        if (st) st.textContent = eve(d, true);
      });
    } catch (e) { /* Intl indisponible : texte du serveur conservé */ }
  }
  function later() { setTimeout(run, 0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', later);
  else later();
  window.addEventListener('load', run);
})();